module.exports = __webpack_public_path__ + "img/1559658974.0e357bae.jpg";